<template>
    <div class="wrap">
        <div class="login-page">
            <form action="javascript:;" @submit="submit">
                <h3>成都购房通</h3>
                <div class="row">
                    <div class="a-input name">
                        <input class="a-input__inner" autocomplete="off" name="name" v-model="name" placeholder="请输入用户名" />
                    </div>
                </div>
                <div class="row">
                    <div class="a-input password">
                        <input type="password" class="a-input__inner" autocomplete="off" name="password" v-model="password" placeholder="请输入密码" />
                    </div>
                </div>
                <div class="row button-box">
                    <button class="a-button a-button--primary"><span>登录</span></button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import Cookie from '@/common/cookie'
import Service from '@/service'

export default {
    name: 'Login',
    beforeRouteEnter (to, from, next) {
        const token = Cookie.getItem('cdfang_token')
        if (token) {
            next(false)
        } else {
            next()
        }
    },
    data () {
        return {
            error: '',
            name: '',
            password: ''
        }
    },
    mounted () {
    },
    computed: {
    },
    methods: {
        submit (e) {
            const data = {
                name: this.name,
                password: this.password
            }
            if (!data.name.trim()) {
                // this.$message.error('请填写用户名')
                return
            }
            if (!data.password.trim()) {
                // this.$message.error('请填写密码')
                return
            }
            Service.login(data).then(({ data }) => {
                Cookie.setItem('cdfang_token', data.token)
                Cookie.setItem('cdfang_nickname', data.user.nickname)
                Cookie.setItem('cdfang_name', data.user.name)
                Cookie.setItem('roles', data.user.roles)
                this.$store.dispatch('setRoles', data.user.roles)
                this.$emit('loginSucess')
                if (data.user.roles.indexOf('advertiser') > -1) {
                    this.$router.replace({
                        path: '/stats'
                    })
                } else if (data.user.roles.indexOf('answerer') > -1) {
                    this.$router.replace({
                        path: '/answer'
                    })
                } else {
                    this.$router.replace({
                        path: '/stats'
                    })
                }
            }).catch((error) => {
                console.log(error)
                // this.$message.error('抱歉登录失败')
            })
        }
    },
    components: {
    }
}
</script>

<style lang="scss" scoped>
.wrap {
    width: 100%;
    flex: 1;
    background: url(../../assets/img/login_bg.png) no-repeat center bottom;
    background-size: cover;
    position: relative;
}
.login-page {
    width: 420px;
    height: 302px;
    text-align: center;
    box-shadow: 0 0 10px 2px rgba(64,207,214,0.32);
    background-color: #fff;
    border-radius: 8px;
    position: absolute;
    left: 50%;
    top: 23.8%;
    transform: translateX(-50%);
    display: flex;
    form {
        width: 100%;
        height: 100%;
        position: relative;
        padding: 70px 40px 0;
    }
    h3 {
        display: block;
        width: 100%;
        height: 38px;
        font-size: 18px;
        color: #fff;
        line-height: 38px;
        font-weight: normal;
        position: absolute;
        top: 0;
        left: 0;
        background: url(../../assets/img/login_box_bg.png) no-repeat center;
        background-size: contain;
    }
    .row {
        & + .row {
            padding-top: 24px;
        }
        &.button-box {
            padding-top: 32px;
        }
    }
    .a-input {
        &::before {
            display: inline-block;
            content: '';
            width: 41px;
            height: 28px;
            background-position: center;
            background-repeat: no-repeat;
            border-right: #ddd solid 1px;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
        }
        &.name {
            &::before {
                background-image: url(../../assets/img/user.png);
                background-size: 20px 24px;
            }
        }
        &.password {
            &::before {
                background-image: url(../../assets/img/password.png);
                background-size: 18px 22px;
            }
        }
    }
    .a-input__inner {
        padding-left: 54px;
    }
    .a-button {
        width: 100%;
        font-size: 20px;
        height: 48px;
    }
}
</style>
